import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

const BVCurations = ({ productCode, content = {}, htmlContent }) => {
  const curationsRef = useRef(null);
  const productId = content.productId || productCode;

  if (!content.widget || !content.visible) {
    return null;
  }

  resetWidget(content, productId).then(() => waitForLoadedImages(curationsRef));

  return createPortal(
    <div
      ref={curationsRef}
      key={`bv_curations-${productCode}`}
      className="ff-bv-curations-wrapper ff-bv-curations-wrapper--pdp invisible"
    >
      <div className="large-10 ff-bv-curations-wrapper__title">
        <h2 className="h5 text-center">{content.title}</h2>
      </div>
      <div className="large-10 ff-bv-curations-wrapper__carousel">
        <div
          data-bv-show="curations"
          data-bv-widget={getBvWidgetName(htmlContent)}
          data-bv-display-tag={content.displayTag}
          {...(content.categoryId
            ? { 'data-bv-category-id': content.categoryId }
            : { 'data-bv-product-id': productId })}
        />
      </div>
    </div>,
    document.getElementById('BVCurations')
  );
};

function resetWidget(content, productId) {
  const INTERVAL = 500;
  return new Promise(resolve => {
    const bvWidgetsLoaded = setInterval(() => {
      if (window.BVWidgets && window.BVWidgets.reset) {
        clearInterval(bvWidgetsLoaded);
        window.BVWidgets.reset(
          {
            display: content.displayTag,
            ...(content.categoryId ? { categoryId: content.categoryId } : { productId }),
          },
          () => {
            return resolve(true);
          }
        );
      }
    }, INTERVAL);
  });
}

function waitForLoadedImages(curationsRef) {
  let counter = 0;
  const INTERVAL = 500;
  const copyNode = curationsRef.current;
  const curationsImagesFetched = setInterval(() => {
    counter += INTERVAL;
    const MAX_SECONDS = 5 * 1000;
    const cImagesWrapper = curationsRef.current.querySelector('.fm-output');
    const gImagesWrapper = curationsRef.current.querySelector('.fm-gridhub-container');
    if (counter >= MAX_SECONDS) {
      clearInterval(curationsImagesFetched);
      if (copyNode.isEqualNode(curationsRef.current)) {
        curationsRef.current.classList.add('display-none');
      }
    }
    if ((cImagesWrapper && cImagesWrapper.children.length) || (gImagesWrapper && gImagesWrapper.children.length)) {
      clearInterval(curationsImagesFetched);
      curationsRef.current.classList.remove('invisible');
    }
  }, INTERVAL);
}

function getBvWidgetName(htmlString) {
  const dataBvWidgetValue = htmlString.match(/data-bv-widget=['|"](?<bvWidget>.{0,})['|"]/);
  return dataBvWidgetValue ? dataBvWidgetValue.groups.bvWidget : '';
}

BVCurations.propTypes = {
  productCode: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])).isRequired,
};

export default BVCurations;
